module.exports = __webpack_public_path__ + "img/patent_image13.d201ad9e.png";